var items = {
  "block.minecraft.air": "повітря",
  "block.minecraft.stone": "камінь",
  "block.minecraft.granite": "граніт",
  "block.minecraft.polished_granite": "полірований граніт",
  "block.minecraft.diorite": "діорит",
  "block.minecraft.polished_diorite": "полірований діорит",
  "block.minecraft.andesite": "андезит",
  "block.minecraft.polished_andesite": "полірований андезит",
  "block.minecraft.grass_block": "блок трави",
  "block.minecraft.dirt": "ґрунт",
  "block.minecraft.coarse_dirt": "загрубілий ґрунт",
  "block.minecraft.podzol": "підзол",
  "block.minecraft.crimson_nylium": "багряний нілій",
  "block.minecraft.warped_nylium": "химерний нілій",
  "block.minecraft.cobblestone": "кругляк",
  "block.minecraft.oak_planks": "дубові дошки",
  "block.minecraft.spruce_planks": "смерекові дошки",
  "block.minecraft.birch_planks": "березові дошки",
  "block.minecraft.jungle_planks": "дошки з тропічного дерева",
  "block.minecraft.acacia_planks": "акацієві дошки",
  "block.minecraft.dark_oak_planks": "дошки з темного дубу",
  "block.minecraft.crimson_planks": "багряні дошки",
  "block.minecraft.warped_planks": "химерні дошки",
  "block.minecraft.oak_sapling": "саджанець дуба",
  "block.minecraft.spruce_sapling": "саджанець смереки",
  "block.minecraft.birch_sapling": "саджанець берези",
  "block.minecraft.jungle_sapling": "саджанець тропічного дерева",
  "block.minecraft.acacia_sapling": "саджанець акації",
  "block.minecraft.dark_oak_sapling": "саджанець темного дуба",
  "block.minecraft.bedrock": "корінна порода",
  "block.minecraft.sand": "пісок",
  "block.minecraft.red_sand": "червоний пісок",
  "block.minecraft.gravel": "гравій",
  "block.minecraft.gold_ore": "золота руда",
  "block.minecraft.iron_ore": "залізна руда",
  "block.minecraft.coal_ore": "вугільна руда",
  "block.minecraft.nether_gold_ore": "золота руда незера",
  "block.minecraft.oak_log": "дубова колода",
  "block.minecraft.spruce_log": "смерекова колода",
  "block.minecraft.birch_log": "березова колода",
  "block.minecraft.jungle_log": "колода тропічного дерева",
  "block.minecraft.acacia_log": "акацієва колода",
  "block.minecraft.dark_oak_log": "колода темного дубу",
  "block.minecraft.crimson_stem": "багряне стебло",
  "block.minecraft.warped_stem": "химерне стебло",
  "block.minecraft.stripped_oak_log": "обтесана дубова колода",
  "block.minecraft.stripped_spruce_log": "обтесана смерекова колода",
  "block.minecraft.stripped_birch_log": "обтесана березова колода",
  "block.minecraft.stripped_jungle_log": "обтесана колода з тропічного дерева",
  "block.minecraft.stripped_acacia_log": "обтесана акацієва колода",
  "block.minecraft.stripped_dark_oak_log": "обтесана колода з темного дубу",
  "block.minecraft.stripped_crimson_stem": "обтесане багряне стебло",
  "block.minecraft.stripped_warped_stem": "обтесане химерне стебло",
  "block.minecraft.stripped_oak_wood": "обтесана дубова деревина",
  "block.minecraft.stripped_spruce_wood": "обтесана смерекова деревина",
  "block.minecraft.stripped_birch_wood": "обтесана березова деревина",
  "block.minecraft.stripped_jungle_wood": "обтесана деревина тропічного дерева",
  "block.minecraft.stripped_acacia_wood": "обтесана акацієва деревина",
  "block.minecraft.stripped_dark_oak_wood": "обтесана деревина темного дубу",
  "block.minecraft.stripped_crimson_hyphae": "обтесані багряні гіфи",
  "block.minecraft.stripped_warped_hyphae": "обтесані химерні гіфи",
  "block.minecraft.oak_wood": "дуб",
  "block.minecraft.spruce_wood": "смерека",
  "block.minecraft.birch_wood": "береза",
  "block.minecraft.jungle_wood": "тропічне дерево",
  "block.minecraft.acacia_wood": "акація",
  "block.minecraft.dark_oak_wood": "темний дуб",
  "block.minecraft.crimson_hyphae": "багряні гіфи",
  "block.minecraft.warped_hyphae": "химерні гіфи",
  "block.minecraft.oak_leaves": "листя дубу",
  "block.minecraft.spruce_leaves": "листя смереки",
  "block.minecraft.birch_leaves": "листя берези",
  "block.minecraft.jungle_leaves": "листя тропічного дерева",
  "block.minecraft.acacia_leaves": "листя акації",
  "block.minecraft.dark_oak_leaves": "листя темного дубу",
  "block.minecraft.sponge": "губка",
  "block.minecraft.wet_sponge": "мокра губка",
  "block.minecraft.glass": "скло",
  "block.minecraft.lapis_ore": "лазуритова руда",
  "block.minecraft.lapis_block": "блок лазуриту",
  "block.minecraft.dispenser": "роздавач",
  "block.minecraft.sandstone": "пісковик",
  "block.minecraft.chiseled_sandstone": "точений пісковик",
  "block.minecraft.cut_sandstone": "тесаний пісковик",
  "block.minecraft.note_block": "нотний блок",
  "block.minecraft.powered_rail": "електризовані рейки",
  "block.minecraft.detector_rail": "детекторні рейки",
  "block.minecraft.sticky_piston": "липкий поршень",
  "block.minecraft.cobweb": "павутиння",
  "block.minecraft.grass": "трава",
  "block.minecraft.fern": "папороть",
  "block.minecraft.dead_bush": "мертвий кущ",
  "block.minecraft.seagrass": "морська трава",
  "block.minecraft.sea_pickle": "морський огірок",
  "block.minecraft.piston": "поршень",
  "block.minecraft.white_wool": "біла вовна",
  "block.minecraft.orange_wool": "помаранчева вовна",
  "block.minecraft.magenta_wool": "пурпурова вовна",
  "block.minecraft.light_blue_wool": "блакитна вовна",
  "block.minecraft.yellow_wool": "жовта вовна",
  "block.minecraft.lime_wool": "лаймова вовна",
  "block.minecraft.pink_wool": "рожева вовна",
  "block.minecraft.gray_wool": "сіра вовна",
  "block.minecraft.light_gray_wool": "світло-сіра вовна",
  "block.minecraft.cyan_wool": "бірюзова вовна",
  "block.minecraft.purple_wool": "фіолетова вовна",
  "block.minecraft.blue_wool": "синя вовна",
  "block.minecraft.brown_wool": "коричнева вовна",
  "block.minecraft.green_wool": "зелена вовна",
  "block.minecraft.red_wool": "червона вовна",
  "block.minecraft.black_wool": "чорна вовна",
  "block.minecraft.dandelion": "кульбаба",
  "block.minecraft.poppy": "мак",
  "block.minecraft.blue_orchid": "блакитна орхідея",
  "block.minecraft.allium": "різанець",
  "block.minecraft.azure_bluet": "черемша",
  "block.minecraft.red_tulip": "червоний тюльпан",
  "block.minecraft.orange_tulip": "помаранчевий тюльпан",
  "block.minecraft.white_tulip": "білий тюльпан",
  "block.minecraft.pink_tulip": "рожевий тюльпан",
  "block.minecraft.oxeye_daisy": "ромашка",
  "block.minecraft.cornflower": "волошка",
  "block.minecraft.lily_of_the_valley": "конвалія",
  "block.minecraft.wither_rose": "троянда висушувача",
  "block.minecraft.brown_mushroom": "коричневий гриб",
  "block.minecraft.red_mushroom": "червоний гриб",
  "block.minecraft.crimson_fungus": "багряний гриб",
  "block.minecraft.warped_fungus": "химерний гриб",
  "block.minecraft.crimson_roots": "багряне коріння",
  "block.minecraft.warped_roots": "химерне коріння",
  "block.minecraft.nether_sprouts": "паростки незера",
  "block.minecraft.weeping_vines": "плакучі лози",
  "block.minecraft.twisting_vines": "кручені лози",
  "block.minecraft.sugar_cane": "цукрова тростина",
  "block.minecraft.kelp": "ламінарія",
  "block.minecraft.bamboo": "бамбук",
  "block.minecraft.gold_block": "золотий блок",
  "block.minecraft.iron_block": "залізний блок",
  "block.minecraft.oak_slab": "дубова плита",
  "block.minecraft.spruce_slab": "смерекова плита",
  "block.minecraft.birch_slab": "березова плита",
  "block.minecraft.jungle_slab": "плита з тропічного дерева",
  "block.minecraft.acacia_slab": "акацієва плита",
  "block.minecraft.dark_oak_slab": "плита з темного дуба",
  "block.minecraft.crimson_slab": "багряна плита",
  "block.minecraft.warped_slab": "химерна плита",
  "block.minecraft.stone_slab": "кам'яна плита",
  "block.minecraft.smooth_stone_slab": "плита з гладкого каменю",
  "block.minecraft.sandstone_slab": "плита з пісковику",
  "block.minecraft.cut_sandstone_slab": "плита з тесаного пісковику",
  "block.minecraft.petrified_oak_slab": "скам'яніла дубова плита",
  "block.minecraft.cobblestone_slab": "плита з кругляку",
  "block.minecraft.brick_slab": "цегляна плита",
  "block.minecraft.stone_brick_slab": "плита з кам'яної цегли",
  "block.minecraft.nether_brick_slab": "плита з незерської цегли",
  "block.minecraft.quartz_slab": "плита з кварцу",
  "block.minecraft.red_sandstone_slab": "плита з червоного пісковику",
  "block.minecraft.cut_red_sandstone_slab": "плита з тесаного червоного пісковику",
  "block.minecraft.purpur_slab": "пурпурова плита",
  "block.minecraft.prismarine_slab": "призмаринова плита",
  "block.minecraft.prismarine_brick_slab": "плита з призмаринової цегли",
  "block.minecraft.dark_prismarine_slab": "плита з темного призмарину",
  "block.minecraft.smooth_quartz": "гладкий кварцовий блок",
  "block.minecraft.smooth_red_sandstone": "гладкий червоний пісковик",
  "block.minecraft.smooth_sandstone": "гладкий пісковик",
  "block.minecraft.smooth_stone": "гладкий камінь",
  "block.minecraft.bricks": "цегла",
  "block.minecraft.tnt": "динаміт",
  "block.minecraft.bookshelf": "книжкова полиця",
  "block.minecraft.mossy_cobblestone": "моховитий кругляк",
  "block.minecraft.obsidian": "обсидіан",
  "block.minecraft.torch": "смолоскип",
  "block.minecraft.end_rod": "ендер-стержень",
  "block.minecraft.chorus_plant": "рослина хорусу",
  "block.minecraft.chorus_flower": "квітка хорусу",
  "block.minecraft.purpur_block": "пурпуровий блок",
  "block.minecraft.purpur_pillar": "пурпурова колонна",
  "block.minecraft.purpur_stairs": "пурпурові сходи",
  "block.minecraft.spawner": "спавнер",
  "block.minecraft.oak_stairs": "дубові сходи",
  "block.minecraft.chest": "скриня",
  "block.minecraft.diamond_ore": "діамантова руда",
  "block.minecraft.diamond_block": "діамантовий блок",
  "block.minecraft.crafting_table": "верстак",
  "block.minecraft.farmland": "рілля",
  "block.minecraft.furnace": "піч",
  "block.minecraft.ladder": "драбина",
  "block.minecraft.rail": "рейки",
  "block.minecraft.cobblestone_stairs": "сходи з кругляку",
  "block.minecraft.lever": "важіль",
  "block.minecraft.stone_pressure_plate": "кам’яна натискна плита",
  "block.minecraft.oak_pressure_plate": "дубова натискна плита",
  "block.minecraft.spruce_pressure_plate": "смерекова натискна плита",
  "block.minecraft.birch_pressure_plate": "березова натискна плита",
  "block.minecraft.jungle_pressure_plate": "натискна плита з тропічного дерева",
  "block.minecraft.acacia_pressure_plate": "акацієва натискна плита",
  "block.minecraft.dark_oak_pressure_plate": "натискна плита з темного дубу",
  "block.minecraft.crimson_pressure_plate": "багряна натискна плита",
  "block.minecraft.warped_pressure_plate": "химерна натискна плита",
  "block.minecraft.polished_blackstone_pressure_plate": "натискна плита з полірованого чорнокаменю",
  "block.minecraft.redstone_ore": "редстоунова руда",
  "block.minecraft.redstone_torch": "смолоскип з редстоуну",
  "block.minecraft.snow": "сніг",
  "block.minecraft.ice": "лід",
  "block.minecraft.snow_block": "блок снігу",
  "block.minecraft.cactus": "кактус",
  "block.minecraft.clay": "блок глини",
  "block.minecraft.jukebox": "програвач",
  "block.minecraft.oak_fence": "дубовий паркан",
  "block.minecraft.spruce_fence": "смерековий паркан",
  "block.minecraft.birch_fence": "березовий паркан",
  "block.minecraft.jungle_fence": "паркан з тропічного дерева",
  "block.minecraft.acacia_fence": "акацієвий паркан",
  "block.minecraft.dark_oak_fence": "паркан з темного дуба",
  "block.minecraft.crimson_fence": "багряний паркан",
  "block.minecraft.warped_fence": "химерний паркан",
  "block.minecraft.pumpkin": "гарбуз",
  "block.minecraft.carved_pumpkin": "вирізаний гарбуз",
  "block.minecraft.netherrack": "незерак",
  "block.minecraft.soul_sand": "пісок душ",
  "block.minecraft.soul_soil": "ґрунт душ",
  "block.minecraft.basalt": "базальт",
  "block.minecraft.polished_basalt": "полірований базальт",
  "block.minecraft.soul_torch": "смолоскип душ",
  "block.minecraft.glowstone": "світлокамінь",
  "block.minecraft.jack_o_lantern": "ліхтар джека",
  "block.minecraft.oak_trapdoor": "дубовий люк",
  "block.minecraft.spruce_trapdoor": "смерековий люк",
  "block.minecraft.birch_trapdoor": "березовий люк",
  "block.minecraft.jungle_trapdoor": "люк з тропічного дерева",
  "block.minecraft.acacia_trapdoor": "акацієвий люк",
  "block.minecraft.dark_oak_trapdoor": "люк із темного дубу",
  "block.minecraft.crimson_trapdoor": "багряний люк",
  "block.minecraft.warped_trapdoor": "химерний люк",
  "block.minecraft.infested_stone": "заражене каміння",
  "block.minecraft.infested_cobblestone": "заражений кругляк",
  "block.minecraft.infested_stone_bricks": "заражена кам'яна цегла",
  "block.minecraft.infested_mossy_stone_bricks": "заражена моховита кам'яна цегла",
  "block.minecraft.infested_cracked_stone_bricks": "заражена тріснута кам'яна цегла",
  "block.minecraft.infested_chiseled_stone_bricks": "заражена точена кам'яна цегла",
  "block.minecraft.stone_bricks": "кам'яна цегла",
  "block.minecraft.mossy_stone_bricks": "моховита кам'яна цегла",
  "block.minecraft.cracked_stone_bricks": "тріснута кам'яна цегла",
  "block.minecraft.chiseled_stone_bricks": "точена кам'яна цегла",
  "block.minecraft.brown_mushroom_block": "блок коричневого гриба",
  "block.minecraft.red_mushroom_block": "блок червоного гриба",
  "block.minecraft.mushroom_stem": "ніжка гриба",
  "block.minecraft.iron_bars": "залізні ґрати",
  "block.minecraft.chain": "ланцюг",
  "block.minecraft.glass_pane": "скляна панель",
  "block.minecraft.melon": "кавун",
  "block.minecraft.vine": "лоза",
  "block.minecraft.oak_fence_gate": "дубова хвіртка",
  "block.minecraft.spruce_fence_gate": "смерекова хвіртка",
  "block.minecraft.birch_fence_gate": "березова хвіртка",
  "block.minecraft.jungle_fence_gate": "хвіртка з тропічного дерева",
  "block.minecraft.acacia_fence_gate": "акацієва хвіртка",
  "block.minecraft.dark_oak_fence_gate": "хвіртка з темного дуба",
  "block.minecraft.crimson_fence_gate": "багряна хвіртка",
  "block.minecraft.warped_fence_gate": "химерна хвіртка",
  "block.minecraft.brick_stairs": "цегляні сходи",
  "block.minecraft.stone_brick_stairs": "сходи з кам'яної цегли",
  "block.minecraft.mycelium": "грибниця",
  "block.minecraft.lily_pad": "латаття",
  "block.minecraft.nether_bricks": "незерська цегла",
  "block.minecraft.cracked_nether_bricks": "тріснута незерська цегла",
  "block.minecraft.chiseled_nether_bricks": "точена незерська цегла",
  "block.minecraft.nether_brick_fence": "паркан з незерської цегли",
  "block.minecraft.nether_brick_stairs": "сходи з незерської цегли",
  "block.minecraft.enchanting_table": "стіл зачарування",
  "block.minecraft.end_portal_frame": "рамка порталу в енд",
  "block.minecraft.end_stone": "камінь енду",
  "block.minecraft.end_stone_bricks": "ендер-цегла",
  "block.minecraft.dragon_egg": "яйце дракона",
  "block.minecraft.redstone_lamp": "лампа",
  "block.minecraft.sandstone_stairs": "сходи з пісковику",
  "block.minecraft.emerald_ore": "смарагдова руда",
  "block.minecraft.ender_chest": "ендер-скриня",
  "block.minecraft.tripwire_hook": "гак для розтяжки",
  "block.minecraft.emerald_block": "смарагдовий блок",
  "block.minecraft.spruce_stairs": "смерекові сходи",
  "block.minecraft.birch_stairs": "березові сходи",
  "block.minecraft.jungle_stairs": "сходи з тропічного дерева",
  "block.minecraft.crimson_stairs": "багряні сходи",
  "block.minecraft.warped_stairs": "химерні сходи",
  "block.minecraft.command_block": "командний блок",
  "block.minecraft.beacon": "маяк",
  "block.minecraft.cobblestone_wall": "стінка з кругляку",
  "block.minecraft.mossy_cobblestone_wall": "стінка з моховитого кругляку",
  "block.minecraft.brick_wall": "цегляна стінка",
  "block.minecraft.prismarine_wall": "призмаринова стінка",
  "block.minecraft.red_sandstone_wall": "стінка з червоного пісковику",
  "block.minecraft.mossy_stone_brick_wall": "стінка з моховитої кам'яної цегли",
  "block.minecraft.granite_wall": "стінка з граніту",
  "block.minecraft.stone_brick_wall": "стінка з кам'яної цегли",
  "block.minecraft.nether_brick_wall": "стінка з незерської цегли",
  "block.minecraft.andesite_wall": "стінка з андезиту",
  "block.minecraft.red_nether_brick_wall": "стінка з червоної незерської цегли",
  "block.minecraft.sandstone_wall": "стінка з пісковику",
  "block.minecraft.end_stone_brick_wall": "стінка з ендер-цегли",
  "block.minecraft.diorite_wall": "стінка з діориту",
  "block.minecraft.blackstone_wall": "стінка з чорнокаменю",
  "block.minecraft.polished_blackstone_wall": "стінка з полірованого чорнокаменю",
  "block.minecraft.polished_blackstone_brick_wall": "стінка з полірованої чорнокам'яної цегли",
  "block.minecraft.stone_button": "кам'яна кнопка",
  "block.minecraft.oak_button": "дубова кнопка",
  "block.minecraft.spruce_button": "смерекова кнопка",
  "block.minecraft.birch_button": "березова кнопка",
  "block.minecraft.jungle_button": "кнопка з тропічного дерева",
  "block.minecraft.acacia_button": "акацієва кнопка",
  "block.minecraft.dark_oak_button": "кнопка з темного дубу",
  "block.minecraft.crimson_button": "багряна кнопка",
  "block.minecraft.warped_button": "химерна кнопка",
  "block.minecraft.polished_blackstone_button": "кнопка з полірованого чорнокаменю",
  "block.minecraft.anvil": "ковадло",
  "block.minecraft.chipped_anvil": "надщерблене ковадло",
  "block.minecraft.damaged_anvil": "пошкоджене ковадло",
  "block.minecraft.trapped_chest": "скриня-пастка",
  "block.minecraft.light_weighted_pressure_plate": "легка вагова плита",
  "block.minecraft.heavy_weighted_pressure_plate": "важка вагова плита",
  "block.minecraft.daylight_detector": "детектор денного світла",
  "block.minecraft.redstone_block": "редстоуновий блок",
  "block.minecraft.nether_quartz_ore": "незер-кварцова руда",
  "block.minecraft.hopper": "воронка",
  "block.minecraft.chiseled_quartz_block": "точений кварцовий блок",
  "block.minecraft.quartz_block": "кварцовий блок",
  "block.minecraft.quartz_bricks": "кварцова цегла",
  "block.minecraft.quartz_pillar": "кварцова колонна",
  "block.minecraft.quartz_stairs": "кварцові сходи",
  "block.minecraft.activator_rail": "активуючі рейки",
  "block.minecraft.dropper": "викидач",
  "block.minecraft.white_terracotta": "біла кераміка",
  "block.minecraft.orange_terracotta": "помаранчева кераміка",
  "block.minecraft.magenta_terracotta": "пурпурова кераміка",
  "block.minecraft.light_blue_terracotta": "блакитна кераміка",
  "block.minecraft.yellow_terracotta": "жовта кераміка",
  "block.minecraft.lime_terracotta": "лаймова кераміка",
  "block.minecraft.pink_terracotta": "рожева кераміка",
  "block.minecraft.gray_terracotta": "сіра кераміка",
  "block.minecraft.light_gray_terracotta": "світло-сіра кераміка",
  "block.minecraft.cyan_terracotta": "бірюзова кераміка",
  "block.minecraft.purple_terracotta": "фіолетова кераміка",
  "block.minecraft.blue_terracotta": "синя кераміка",
  "block.minecraft.brown_terracotta": "коричнева кераміка",
  "block.minecraft.green_terracotta": "зелена кераміка",
  "block.minecraft.red_terracotta": "червона кераміка",
  "block.minecraft.black_terracotta": "чорна кераміка",
  "block.minecraft.barrier": "бар'єр",
  "block.minecraft.iron_trapdoor": "залізний люк",
  "block.minecraft.hay_block": "копиця сіна",
  "block.minecraft.white_carpet": "білий килим",
  "block.minecraft.orange_carpet": "помаранчевий килим",
  "block.minecraft.magenta_carpet": "пурпуровий килим",
  "block.minecraft.light_blue_carpet": "блакитний килим",
  "block.minecraft.yellow_carpet": "жовтий килим",
  "block.minecraft.lime_carpet": "лаймовий килим",
  "block.minecraft.pink_carpet": "рожевий килим",
  "block.minecraft.gray_carpet": "сірий килим",
  "block.minecraft.light_gray_carpet": "світло-сірий килим",
  "block.minecraft.cyan_carpet": "бірюзовий килим",
  "block.minecraft.purple_carpet": "фіолетовий килим",
  "block.minecraft.blue_carpet": "синій килим",
  "block.minecraft.brown_carpet": "коричневий килим",
  "block.minecraft.green_carpet": "зелений килим",
  "block.minecraft.red_carpet": "червоний килим",
  "block.minecraft.black_carpet": "чорний килим",
  "block.minecraft.terracotta": "теракота",
  "block.minecraft.coal_block": "вугільний блок",
  "block.minecraft.packed_ice": "сухий лід",
  "block.minecraft.acacia_stairs": "акацієві сходи",
  "block.minecraft.dark_oak_stairs": "сходи з темного дуба",
  "block.minecraft.slime_block": "блок слизу",
  "block.minecraft.grass_path": "стежка",
  "block.minecraft.sunflower": "соняшник",
  "block.minecraft.lilac": "бузок",
  "block.minecraft.rose_bush": "трояндовий кущ",
  "block.minecraft.peony": "півонія",
  "block.minecraft.tall_grass": "висока трава",
  "block.minecraft.large_fern": "велика папороть",
  "block.minecraft.white_stained_glass": "біле скло",
  "block.minecraft.orange_stained_glass": "помаранчеве скло",
  "block.minecraft.magenta_stained_glass": "пурпурове скло",
  "block.minecraft.light_blue_stained_glass": "блакитне скло",
  "block.minecraft.yellow_stained_glass": "жовте скло",
  "block.minecraft.lime_stained_glass": "лаймове скло",
  "block.minecraft.pink_stained_glass": "рожеве скло",
  "block.minecraft.gray_stained_glass": "сіре скло",
  "block.minecraft.light_gray_stained_glass": "світло-сіре скло",
  "block.minecraft.cyan_stained_glass": "бірюзове скло",
  "block.minecraft.purple_stained_glass": "фіолетове скло",
  "block.minecraft.blue_stained_glass": "синє скло",
  "block.minecraft.brown_stained_glass": "коричневе скло",
  "block.minecraft.green_stained_glass": "зелене скло",
  "block.minecraft.red_stained_glass": "червоне скло",
  "block.minecraft.black_stained_glass": "чорне скло",
  "block.minecraft.white_stained_glass_pane": "біла скляна панель",
  "block.minecraft.orange_stained_glass_pane": "помаранчева скляна панель",
  "block.minecraft.magenta_stained_glass_pane": "пурпурова скляна панель",
  "block.minecraft.light_blue_stained_glass_pane": "блакитна скляна панель",
  "block.minecraft.yellow_stained_glass_pane": "жовта скляна панель",
  "block.minecraft.lime_stained_glass_pane": "лаймова скляна панель",
  "block.minecraft.pink_stained_glass_pane": "рожева скляна панель",
  "block.minecraft.gray_stained_glass_pane": "сіра скляна панель",
  "block.minecraft.light_gray_stained_glass_pane": "світло-сіра скляна панель",
  "block.minecraft.cyan_stained_glass_pane": "бірюзова скляна панель",
  "block.minecraft.purple_stained_glass_pane": "фіолетова скляна панель",
  "block.minecraft.blue_stained_glass_pane": "синя скляна панель",
  "block.minecraft.brown_stained_glass_pane": "коричнева скляна панель",
  "block.minecraft.green_stained_glass_pane": "зелена скляна панель",
  "block.minecraft.red_stained_glass_pane": "червона скляна панель",
  "block.minecraft.black_stained_glass_pane": "чорна скляна панель",
  "block.minecraft.prismarine": "призмарин",
  "block.minecraft.prismarine_bricks": "призмаринова цегла",
  "block.minecraft.dark_prismarine": "темний призмарин",
  "block.minecraft.prismarine_stairs": "призмаринові сходи",
  "block.minecraft.prismarine_brick_stairs": "сходи з призмаринової цегли",
  "block.minecraft.dark_prismarine_stairs": "сходи з темного призмарину",
  "block.minecraft.sea_lantern": "морський ліхтар",
  "block.minecraft.red_sandstone": "червоний пісковик",
  "block.minecraft.chiseled_red_sandstone": "точений червоний пісковик",
  "block.minecraft.cut_red_sandstone": "тесаний червоний пісковик",
  "block.minecraft.red_sandstone_stairs": "сходи з червоного пісковику",
  "block.minecraft.repeating_command_block": "повторюючий командний блок",
  "block.minecraft.chain_command_block": "ланцюговий командний блок",
  "block.minecraft.magma_block": "блок магми",
  "block.minecraft.nether_wart_block": "блок незерського наросту",
  "block.minecraft.warped_wart_block": "блок химерного наросту",
  "block.minecraft.red_nether_bricks": "червона незерська цегла",
  "block.minecraft.bone_block": "кістяний блок",
  "block.minecraft.structure_void": "структурна порожнеча",
  "block.minecraft.observer": "спостерігач",
  "block.minecraft.shulker_box": "коробка шалкера",
  "block.minecraft.white_shulker_box": "біла коробка шалкера",
  "block.minecraft.orange_shulker_box": "помаранчева коробка шалкера",
  "block.minecraft.magenta_shulker_box": "пурпурова коробка шалкера",
  "block.minecraft.light_blue_shulker_box": "блакитна коробка шалкера",
  "block.minecraft.yellow_shulker_box": "жовта коробка шалкера",
  "block.minecraft.lime_shulker_box": "лаймова коробка шалкера",
  "block.minecraft.pink_shulker_box": "рожева коробка шалкера",
  "block.minecraft.gray_shulker_box": "сіра коробка шалкера",
  "block.minecraft.light_gray_shulker_box": "світло-сіра коробка шалкера",
  "block.minecraft.cyan_shulker_box": "бірюзова коробка шалкера",
  "block.minecraft.purple_shulker_box": "фіолетова коробка шалкера",
  "block.minecraft.blue_shulker_box": "синя коробка шалкера",
  "block.minecraft.brown_shulker_box": "коричнева коробка шалкера",
  "block.minecraft.green_shulker_box": "зелена коробка шалкера",
  "block.minecraft.red_shulker_box": "червона коробка шалкера",
  "block.minecraft.black_shulker_box": "чорна коробка шалкера",
  "block.minecraft.white_glazed_terracotta": "біла глазурована кераміка",
  "block.minecraft.orange_glazed_terracotta": "помаранчева глазурована кераміка",
  "block.minecraft.magenta_glazed_terracotta": "пурпурова глазурована кераміка",
  "block.minecraft.light_blue_glazed_terracotta": "блакитна глазурована кераміка",
  "block.minecraft.yellow_glazed_terracotta": "жовта глазурована кераміка",
  "block.minecraft.lime_glazed_terracotta": "лаймова глазурована кераміка",
  "block.minecraft.pink_glazed_terracotta": "рожева глазурована кераміка",
  "block.minecraft.gray_glazed_terracotta": "сіра глазурована кераміка",
  "block.minecraft.light_gray_glazed_terracotta": "світло-сіра глазурована кераміка",
  "block.minecraft.cyan_glazed_terracotta": "бірюзова глазурована кераміка",
  "block.minecraft.purple_glazed_terracotta": "фіолетова глазурована кераміка",
  "block.minecraft.blue_glazed_terracotta": "синя глазурована кераміка",
  "block.minecraft.brown_glazed_terracotta": "коричнева глазурована кераміка",
  "block.minecraft.green_glazed_terracotta": "зелена глазурована кераміка",
  "block.minecraft.red_glazed_terracotta": "червона глазурована кераміка",
  "block.minecraft.black_glazed_terracotta": "чорна глазурована кераміка",
  "block.minecraft.white_concrete": "білий бетон",
  "block.minecraft.orange_concrete": "помаранчевий бетон",
  "block.minecraft.magenta_concrete": "пурпуровий бетон",
  "block.minecraft.light_blue_concrete": "блакитний бетон",
  "block.minecraft.yellow_concrete": "жовтий бетон",
  "block.minecraft.lime_concrete": "лаймовий бетон",
  "block.minecraft.pink_concrete": "рожевий бетон",
  "block.minecraft.gray_concrete": "сірий бетон",
  "block.minecraft.light_gray_concrete": "світло-сірий бетон",
  "block.minecraft.cyan_concrete": "бірюзовий бетон",
  "block.minecraft.purple_concrete": "фіолетовий бетон",
  "block.minecraft.blue_concrete": "синій бетон",
  "block.minecraft.brown_concrete": "коричневий бетон",
  "block.minecraft.green_concrete": "зелений бетон",
  "block.minecraft.red_concrete": "червоний бетон",
  "block.minecraft.black_concrete": "чорний бетон",
  "block.minecraft.white_concrete_powder": "білий цемент",
  "block.minecraft.orange_concrete_powder": "помаранчевий цемент",
  "block.minecraft.magenta_concrete_powder": "пурпуровий цемент",
  "block.minecraft.light_blue_concrete_powder": "блакитний цемент",
  "block.minecraft.yellow_concrete_powder": "жовтий цемент",
  "block.minecraft.lime_concrete_powder": "лаймовий цемент",
  "block.minecraft.pink_concrete_powder": "рожевий цемент",
  "block.minecraft.gray_concrete_powder": "сірий цемент",
  "block.minecraft.light_gray_concrete_powder": "світло-сірий цемент",
  "block.minecraft.cyan_concrete_powder": "бірюзовий цемент",
  "block.minecraft.purple_concrete_powder": "фіолетовий цемент",
  "block.minecraft.blue_concrete_powder": "синій цемент",
  "block.minecraft.brown_concrete_powder": "коричневий цемент",
  "block.minecraft.green_concrete_powder": "зелений цемент",
  "block.minecraft.red_concrete_powder": "червоний цемент",
  "block.minecraft.black_concrete_powder": "чорний цемент",
  "block.minecraft.turtle_egg": "яйце черепахи",
  "block.minecraft.dead_tube_coral_block": "блок мертвих трубчастих коралів",
  "block.minecraft.dead_brain_coral_block": "блок мертвих мозкових коралів",
  "block.minecraft.dead_bubble_coral_block": "блок мертвого бульбашкового коралу",
  "block.minecraft.dead_fire_coral_block": "блок мертвих вогняних коралів",
  "block.minecraft.dead_horn_coral_block": "блок мертвих рогових коралів",
  "block.minecraft.tube_coral_block": "блок трубчастих коралів",
  "block.minecraft.brain_coral_block": "блок мозкових коралів",
  "block.minecraft.bubble_coral_block": "блок бульбашкових коралів",
  "block.minecraft.fire_coral_block": "блок вогняних коралів",
  "block.minecraft.horn_coral_block": "блок рогових коралів",
  "block.minecraft.tube_coral": "трубчастий корал",
  "block.minecraft.brain_coral": "мозковий корал",
  "block.minecraft.bubble_coral": "бульбашковий корал",
  "block.minecraft.fire_coral": "вогняний корал",
  "block.minecraft.horn_coral": "роговий корал",
  "block.minecraft.dead_brain_coral": "мертвий мозковий корал",
  "block.minecraft.dead_bubble_coral": "мертвий бульбашковий корал",
  "block.minecraft.dead_fire_coral": "мертвий вогняний корал",
  "block.minecraft.dead_horn_coral": "мертвий роговий корал",
  "block.minecraft.dead_tube_coral": "мертві трубчасті корали",
  "block.minecraft.tube_coral_fan": "віяло з трубчастих коралів",
  "block.minecraft.brain_coral_fan": "віяло з мозкових коралів",
  "block.minecraft.bubble_coral_fan": "віяло з бульбашкових коралів",
  "block.minecraft.fire_coral_fan": "віяло з вогняних коралів",
  "block.minecraft.horn_coral_fan": "віяло з рогових коралів",
  "block.minecraft.dead_tube_coral_fan": "мертве віяло трубчастих коралів",
  "block.minecraft.dead_brain_coral_fan": "мертве віяло мозкових коралів",
  "block.minecraft.dead_bubble_coral_fan": "мертве віяло бульбашкових коралів",
  "block.minecraft.dead_fire_coral_fan": "мертве віяло вогняних коралів",
  "block.minecraft.dead_horn_coral_fan": "мертве віяло рогових коралів",
  "block.minecraft.blue_ice": "синій лід",
  "block.minecraft.conduit": "провідник",
  "block.minecraft.polished_granite_stairs": "сходи з полірованого граніту",
  "block.minecraft.smooth_red_sandstone_stairs": "сходи з гладкого червоного пісковику",
  "block.minecraft.mossy_stone_brick_stairs": "сходи з моховитої кам'яної цегли",
  "block.minecraft.polished_diorite_stairs": "сходи з полірованого діориту",
  "block.minecraft.mossy_cobblestone_stairs": "сходи з моховитого кругляку",
  "block.minecraft.end_stone_brick_stairs": "сходи з ендер-цегли",
  "block.minecraft.stone_stairs": "кам'яні сходи",
  "block.minecraft.smooth_sandstone_stairs": "сходи з гладкого пісковику",
  "block.minecraft.smooth_quartz_stairs": "сходи з гладкого кварцу",
  "block.minecraft.granite_stairs": "сходи з граніту",
  "block.minecraft.andesite_stairs": "сходи з андезиту",
  "block.minecraft.red_nether_brick_stairs": "сходи з червоної незерської цегли",
  "block.minecraft.polished_andesite_stairs": "сходи з полірованого андезиту",
  "block.minecraft.diorite_stairs": "сходи з діориту",
  "block.minecraft.polished_granite_slab": "плита з полірованого граніту",
  "block.minecraft.smooth_red_sandstone_slab": "плита з гладкого червоного пісковику",
  "block.minecraft.mossy_stone_brick_slab": "плита з моховитої кам'яної цегли",
  "block.minecraft.polished_diorite_slab": "плита з полірованого діориту",
  "block.minecraft.mossy_cobblestone_slab": "плита з моховитого кругляку",
  "block.minecraft.end_stone_brick_slab": "плита з ендер-цегли",
  "block.minecraft.smooth_sandstone_slab": "плита з гладкого пісковику",
  "block.minecraft.smooth_quartz_slab": "плита з гладкого кварцу",
  "block.minecraft.granite_slab": "плита з граніту",
  "block.minecraft.andesite_slab": "плита з андезиту",
  "block.minecraft.red_nether_brick_slab": "плита з червоної незерської цегли",
  "block.minecraft.polished_andesite_slab": "плита з полірованого андезиту",
  "block.minecraft.diorite_slab": "плита з діориту",
  "block.minecraft.scaffolding": "риштування",
  "block.minecraft.iron_door": "залізні двері",
  "block.minecraft.oak_door": "дубові двері",
  "block.minecraft.spruce_door": "смерекові двері",
  "block.minecraft.birch_door": "березові двері",
  "block.minecraft.jungle_door": "двері з тропічного дерева",
  "block.minecraft.acacia_door": "акацієві двері",
  "block.minecraft.dark_oak_door": "двері з темного дубу",
  "block.minecraft.crimson_door": "багряні двері",
  "block.minecraft.warped_door": "химерні двері",
  "block.minecraft.repeater": "редстоуновий повторювач",
  "block.minecraft.comparator": "редстоуновий компаратор",
  "block.minecraft.structure_block": "структурний блок",
  "block.minecraft.jigsaw": "блок пазлу",
  "item.minecraft.turtle_helmet": "панцир черепахи□□коли одягнено на голові:□+2 броня",
  "item.minecraft.scute": "черепок",
  "item.minecraft.iron_shovel": "залізна лопата□□коли в основній руці:□+3.5 сила атаки□-3 швидкість атаки",
  "item.minecraft.iron_pickaxe": "залізне кайло□□коли в основній руці:□+3 сила атаки□-2.8 швидкість атаки",
  "item.minecraft.iron_axe": "залізна сокира□□коли в основній руці:□+8 сила атаки□-3.1 швидкість атаки",
  "item.minecraft.flint_and_steel": "кресало",
  "item.minecraft.apple": "яблуко",
  "item.minecraft.bow": "лук",
  "item.minecraft.arrow": "стріла",
  "item.minecraft.coal": "вугілля",
  "item.minecraft.charcoal": "деревне вугілля",
  "item.minecraft.diamond": "діамант",
  "item.minecraft.iron_ingot": "залізний злиток",
  "item.minecraft.gold_ingot": "золотий злиток",
  "item.minecraft.netherite_ingot": "незеритовий злиток",
  "item.minecraft.netherite_scrap": "незеритовий уламок",
  "item.minecraft.iron_sword": "залізний меч□□коли в основній руці:□+5 сила атаки□-2.4 швидкість атаки",
  "item.minecraft.wooden_sword": "дерев'яний меч□□коли в основній руці:□+3 сила атаки□-2.4 швидкість атаки",
  "item.minecraft.wooden_shovel": "дерев'яна лопата□□коли в основній руці:□+1.5 сила атаки□-3 швидкість атаки",
  "item.minecraft.wooden_pickaxe": "дерев'яне кайло□□коли в основній руці:□+1 сила атаки□-2.8 швидкість атаки",
  "item.minecraft.wooden_axe": "дерев'яна сокира□□коли в основній руці:□+6 сила атаки□-3.2 швидкість атаки",
  "item.minecraft.stone_sword": "кам'яний меч□□коли в основній руці:□+4 сила атаки□-2.4 швидкість атаки",
  "item.minecraft.stone_shovel": "кам'яна лопата□□коли в основній руці:□+2.5 сила атаки□-3 швидкість атаки",
  "item.minecraft.stone_pickaxe": "кам'яне кайло□□коли в основній руці:□+2 сила атаки□-2.8 швидкість атаки",
  "item.minecraft.stone_axe": "кам'яна сокира□□коли в основній руці:□+8 сила атаки□-3.2 швидкість атаки",
  "item.minecraft.diamond_sword": "діамантовий меч□□коли в основній руці:□+6 сила атаки□-2.4 швидкість атаки",
  "item.minecraft.diamond_shovel": "діамантова лопата□□коли в основній руці:□+4.5 сила атаки□-3 швидкість атаки",
  "item.minecraft.diamond_pickaxe": "діамантове кайло□□коли в основній руці:□+4 сила атаки□-2.8 швидкість атаки",
  "item.minecraft.diamond_axe": "діамантова сокира□□коли в основній руці:□+8 сила атаки□-3 швидкість атаки",
  "item.minecraft.stick": "палиця",
  "item.minecraft.bowl": "миска",
  "item.minecraft.mushroom_stew": "тушковані гриби",
  "item.minecraft.golden_sword": "золотий меч□□коли в основній руці:□+3 сила атаки□-2.4 швидкість атаки",
  "item.minecraft.golden_shovel": "золота лопата□□коли в основній руці:□+1.5 сила атаки□-3 швидкість атаки",
  "item.minecraft.golden_pickaxe": "золоте кайло□□коли в основній руці:□+1 сила атаки□-2.8 швидкість атаки",
  "item.minecraft.golden_axe": "золота сокира□□коли в основній руці:□+6 сила атаки□-3 швидкість атаки",
  "item.minecraft.netherite_sword": "незеритовий меч□□коли в основній руці:□+7 сила атаки□-2.4 швидкість атаки",
  "item.minecraft.netherite_shovel": "незеритова лопата□□коли в основній руці:□+5.5 сила атаки□-3 швидкість атаки",
  "item.minecraft.netherite_pickaxe": "незеритове кайло□□коли в основній руці:□+5 сила атаки□-2.8 швидкість атаки",
  "item.minecraft.netherite_axe": "незеритова сокира□□коли в основній руці:□+9 сила атаки□-3 швидкість атаки",
  "item.minecraft.string": "нитка",
  "item.minecraft.feather": "перо",
  "item.minecraft.gunpowder": "порох",
  "item.minecraft.wooden_hoe": "дерев'яна мотика□□коли в основній руці:□-3 швидкість атаки",
  "item.minecraft.stone_hoe": "кам'яна мотика□□коли в основній руці:□-2 швидкість атаки",
  "item.minecraft.iron_hoe": "залізна мотика□□коли в основній руці:□-1 швидкість атаки",
  "item.minecraft.diamond_hoe": "діамантова мотика□□коли в основній руці:",
  "item.minecraft.golden_hoe": "золота мотика□□коли в основній руці:□-3 швидкість атаки",
  "item.minecraft.netherite_hoe": "незеритова мотика□□коли в основній руці:",
  "item.minecraft.wheat_seeds": "насіння пшениці",
  "item.minecraft.wheat": "пшениця",
  "item.minecraft.bread": "хліб",
  "item.minecraft.leather_helmet": "шкіряна шапка□□коли одягнено на голові:□+1 броня",
  "item.minecraft.leather_chestplate": "шкіряна туніка□□коли одягнено на грудях:□+3 броня",
  "item.minecraft.leather_leggings": "шкіряні штани□□коли одягнено на ноги:□+2 броня",
  "item.minecraft.leather_boots": "шкіряні чоботи□□коли взуте:□+1 броня",
  "item.minecraft.chainmail_helmet": "кольчужний шолом□□коли одягнено на голові:□+2 броня",
  "item.minecraft.chainmail_chestplate": "кольчужний нагрудник□□коли одягнено на грудях:□+5 броня",
  "item.minecraft.chainmail_leggings": "кольчужні наголінники□□коли одягнено на ноги:□+4 броня",
  "item.minecraft.chainmail_boots": "кольчужні чоботи□□коли взуте:□+1 броня",
  "item.minecraft.iron_helmet": "залізний шолом□□коли одягнено на голові:□+2 броня",
  "item.minecraft.iron_chestplate": "залізний нагрудник□□коли одягнено на грудях:□+6 броня",
  "item.minecraft.iron_leggings": "залізні наголінники□□коли одягнено на ноги:□+5 броня",
  "item.minecraft.iron_boots": "залізні чоботи□□коли взуте:□+2 броня",
  "item.minecraft.diamond_helmet": "діамантовий шолом□□коли одягнено на голові:□+3 броня□+2 міцність броні",
  "item.minecraft.diamond_chestplate": "діамантовий нагрудник□□коли одягнено на грудях:□+8 броня□+2 міцність броні",
  "item.minecraft.diamond_leggings": "діамантові наголінники□□коли одягнено на ноги:□+6 броня□+2 міцність броні",
  "item.minecraft.diamond_boots": "діамантові чоботи□□коли взуте:□+3 броня□+2 міцність броні",
  "item.minecraft.golden_helmet": "золотий шолом□□коли одягнено на голові:□+2 броня",
  "item.minecraft.golden_chestplate": "золотий нагрудник□□коли одягнено на грудях:□+5 броня",
  "item.minecraft.golden_leggings": "золоті наголінники□□коли одягнено на ноги:□+3 броня",
  "item.minecraft.golden_boots": "золоті чоботи□□коли взуте:□+1 броня",
  "item.minecraft.netherite_helmet": "незеритовий шолом□□коли одягнено на голові:□+3 броня□+3 міцність броні□+1 стійкість до відкидування",
  "item.minecraft.netherite_chestplate": "незеритовий нагрудник□□коли одягнено на грудях:□+8 броня□+3 міцність броні□+1 стійкість до відкидування",
  "item.minecraft.netherite_leggings": "незеритові наголінники□□коли одягнено на ноги:□+6 броня□+3 міцність броні□+1 стійкість до відкидування",
  "item.minecraft.netherite_boots": "незеритові чоботи□□коли взуте:□+3 броня□+3 міцність броні□+1 стійкість до відкидування",
  "item.minecraft.flint": "кремінь",
  "item.minecraft.porkchop": "сира свинина",
  "item.minecraft.cooked_porkchop": "смажена свинина",
  "item.minecraft.painting": "картина",
  "item.minecraft.golden_apple": "золоте яблуко",
  "item.minecraft.enchanted_golden_apple": "зачароване золоте яблуко",
  "block.minecraft.oak_sign": "дубова табличка",
  "block.minecraft.spruce_sign": "смерекова табличка",
  "block.minecraft.birch_sign": "березова табличка",
  "block.minecraft.jungle_sign": "табличка з тропічного дерева",
  "block.minecraft.acacia_sign": "акацієва табличка",
  "block.minecraft.dark_oak_sign": "табличка з темного дубу",
  "block.minecraft.crimson_sign": "багряна табличка",
  "block.minecraft.warped_sign": "химерна табличка",
  "item.minecraft.bucket": "відро",
  "item.minecraft.water_bucket": "відро води",
  "item.minecraft.lava_bucket": "відро лави",
  "item.minecraft.minecart": "вагонетка",
  "item.minecraft.saddle": "сідло",
  "item.minecraft.redstone": "редстоун",
  "item.minecraft.snowball": "сніжка",
  "item.minecraft.oak_boat": "дубовий човен",
  "item.minecraft.leather": "шкіра",
  "item.minecraft.milk_bucket": "відро молока",
  "item.minecraft.pufferfish_bucket": "відро із скелезубом",
  "item.minecraft.salmon_bucket": "відро з лососем",
  "item.minecraft.cod_bucket": "відро з тріскою",
  "item.minecraft.tropical_fish_bucket": "відро з тропічною рибою",
  "item.minecraft.brick": "цеглина",
  "item.minecraft.clay_ball": "глиняна кулька",
  "block.minecraft.dried_kelp_block": "блок висушеної ламінарії",
  "item.minecraft.paper": "папір",
  "item.minecraft.book": "книга",
  "item.minecraft.slime_ball": "слизова кулька",
  "item.minecraft.chest_minecart": "вагонетка зі скринею",
  "item.minecraft.furnace_minecart": "вагонетка з піччю",
  "item.minecraft.egg": "яйце",
  "item.minecraft.compass": "компас",
  "item.minecraft.fishing_rod": "вудка",
  "item.minecraft.clock": "годинник",
  "item.minecraft.glowstone_dust": "пил світлокаменю",
  "item.minecraft.cod": "сира тріска",
  "item.minecraft.salmon": "сирий лосось",
  "item.minecraft.tropical_fish": "тропічна риба",
  "item.minecraft.pufferfish": "скелезуб",
  "item.minecraft.cooked_cod": "смажена тріска",
  "item.minecraft.cooked_salmon": "смажений лосось",
  "item.minecraft.ink_sac": "чорнильний мішок",
  "item.minecraft.red_dye": "червоний барвник",
  "item.minecraft.green_dye": "зелений барвник",
  "item.minecraft.cocoa_beans": "какао-боби",
  "item.minecraft.lapis_lazuli": "лазурит",
  "item.minecraft.purple_dye": "фіолетовий барвник",
  "item.minecraft.cyan_dye": "бірюзовий барвник",
  "item.minecraft.light_gray_dye": "світло-сірий барвник",
  "item.minecraft.gray_dye": "сірий барвник",
  "item.minecraft.pink_dye": "рожевий барвник",
  "item.minecraft.lime_dye": "лаймовий барвник",
  "item.minecraft.yellow_dye": "жовтий барвник",
  "item.minecraft.light_blue_dye": "блакитний барвник",
  "item.minecraft.magenta_dye": "пурпуровий барвник",
  "item.minecraft.orange_dye": "помаранчевий барвник",
  "item.minecraft.bone_meal": "кісткове борошно",
  "item.minecraft.blue_dye": "синій барвник",
  "item.minecraft.brown_dye": "коричневий барвник",
  "item.minecraft.black_dye": "чорний барвник",
  "item.minecraft.white_dye": "білий барвник",
  "item.minecraft.bone": "кістка",
  "item.minecraft.sugar": "цукор",
  "block.minecraft.cake": "торт",
  "block.minecraft.white_bed": "біле ліжко",
  "block.minecraft.orange_bed": "помаранчеве ліжко",
  "block.minecraft.magenta_bed": "пурпурове ліжко",
  "block.minecraft.light_blue_bed": "блакитне ліжко",
  "block.minecraft.yellow_bed": "жовте ліжко",
  "block.minecraft.lime_bed": "лаймове ліжко",
  "block.minecraft.pink_bed": "рожеве ліжко",
  "block.minecraft.gray_bed": "сіре ліжко",
  "block.minecraft.light_gray_bed": "світло-сіре ліжко",
  "block.minecraft.cyan_bed": "бірюзове ліжко",
  "block.minecraft.purple_bed": "фіолетове ліжко",
  "block.minecraft.blue_bed": "синє ліжко",
  "block.minecraft.brown_bed": "коричневе ліжко",
  "block.minecraft.green_bed": "зелене ліжко",
  "block.minecraft.red_bed": "червоне ліжко",
  "block.minecraft.black_bed": "чорне ліжко",
  "item.minecraft.cookie": "печиво",
  "item.minecraft.filled_map": "мапа□#0",
  "item.minecraft.shears": "ножиці",
  "item.minecraft.melon_slice": "скибка кавуна",
  "item.minecraft.dried_kelp": "висушена ламінарія",
  "item.minecraft.pumpkin_seeds": "насіння гарбуза",
  "item.minecraft.melon_seeds": "насіння кавуна",
  "item.minecraft.beef": "сира яловичина",
  "item.minecraft.cooked_beef": "стейк",
  "item.minecraft.chicken": "сира курятина",
  "item.minecraft.cooked_chicken": "смажена курятина",
  "item.minecraft.rotten_flesh": "гнила плоть",
  "item.minecraft.ender_pearl": "перлина енду",
  "item.minecraft.blaze_rod": "жезл блейза",
  "item.minecraft.ghast_tear": "сльоза ґаста",
  "item.minecraft.gold_nugget": "золотий самородок",
  "item.minecraft.nether_wart": "незерський наріст",
  "item.minecraft.potion": "нестворюване зілля□немає ефектів",
  "item.minecraft.glass_bottle": "пляшечка",
  "item.minecraft.spider_eye": "павуче око",
  "item.minecraft.fermented_spider_eye": "оброблене павуче око",
  "item.minecraft.blaze_powder": "пил блейза",
  "item.minecraft.magma_cream": "магмовий крем",
  "block.minecraft.brewing_stand": "варильна стійка",
  "block.minecraft.cauldron": "казан",
  "item.minecraft.ender_eye": "око енду",
  "item.minecraft.glistering_melon_slice": "блискуча скибка кавуна",
  "item.minecraft.bat_spawn_egg": "яйце виклику кажана",
  "item.minecraft.bee_spawn_egg": "яйце виклику бджоли",
  "item.minecraft.blaze_spawn_egg": "яйце виклику блейза",
  "item.minecraft.cat_spawn_egg": "яйце виклику кота",
  "item.minecraft.cave_spider_spawn_egg": "яйце виклику печерного павука",
  "item.minecraft.chicken_spawn_egg": "яйце виклику курки",
  "item.minecraft.cod_spawn_egg": "яйце виклику тріски",
  "item.minecraft.cow_spawn_egg": "яйце виклику корови",
  "item.minecraft.creeper_spawn_egg": "яйце виклику кріпера",
  "item.minecraft.dolphin_spawn_egg": "яйце виклику дельфіна",
  "item.minecraft.donkey_spawn_egg": "яйце виклику віслюка",
  "item.minecraft.drowned_spawn_egg": "яйце виклику водяника",
  "item.minecraft.elder_guardian_spawn_egg": "яйце виклику стародавнього вартового",
  "item.minecraft.enderman_spawn_egg": "яйце виклику ендермена",
  "item.minecraft.endermite_spawn_egg": "яйце виклику ендерміта",
  "item.minecraft.evoker_spawn_egg": "яйце виклику заклинателя",
  "item.minecraft.fox_spawn_egg": "яйце виклику лисиці",
  "item.minecraft.ghast_spawn_egg": "яйце виклику ґаста",
  "item.minecraft.guardian_spawn_egg": "яйце виклику вартового",
  "item.minecraft.hoglin_spawn_egg": "яйце виклику гоґліна",
  "item.minecraft.horse_spawn_egg": "яйце виклику коня",
  "item.minecraft.husk_spawn_egg": "яйце виклику висушня",
  "item.minecraft.llama_spawn_egg": "яйце виклику лами",
  "item.minecraft.magma_cube_spawn_egg": "яйце виклику магмакуба",
  "item.minecraft.mooshroom_spawn_egg": "яйце виклику муухомора",
  "item.minecraft.mule_spawn_egg": "яйце виклику мула",
  "item.minecraft.ocelot_spawn_egg": "яйце виклику оцелота",
  "item.minecraft.panda_spawn_egg": "яйце виклику панди",
  "item.minecraft.parrot_spawn_egg": "яйце виклику папуги",
  "item.minecraft.phantom_spawn_egg": "яйце виклику фантома",
  "item.minecraft.pig_spawn_egg": "яйце виклику свині",
  "item.minecraft.piglin_spawn_egg": "яйце виклику піґліна",
  "item.minecraft.pillager_spawn_egg": "яйце виклику розбійника",
  "item.minecraft.polar_bear_spawn_egg": "яйце виклику білого ведмедя",
  "item.minecraft.pufferfish_spawn_egg": "яйце виклику скелезуба",
  "item.minecraft.rabbit_spawn_egg": "яйце виклику кролика",
  "item.minecraft.ravager_spawn_egg": "яйце виклику руйнівника",
  "item.minecraft.salmon_spawn_egg": "яйце виклику лосося",
  "item.minecraft.sheep_spawn_egg": "яйце виклику вівці",
  "item.minecraft.shulker_spawn_egg": "яйце виклику шалкера",
  "item.minecraft.silverfish_spawn_egg": "яйце виклику лусківниці",
  "item.minecraft.skeleton_spawn_egg": "яйце виклику скелета",
  "item.minecraft.skeleton_horse_spawn_egg": "яйце виклику коня-скелета",
  "item.minecraft.slime_spawn_egg": "яйце виклику слимака",
  "item.minecraft.spider_spawn_egg": "яйце виклику павука",
  "item.minecraft.squid_spawn_egg": "яйце виклику спрута",
  "item.minecraft.stray_spawn_egg": "яйце виклику примари",
  "item.minecraft.strider_spawn_egg": "яйце виклику блукача",
  "item.minecraft.trader_llama_spawn_egg": "яйце виклику лами торговця",
  "item.minecraft.tropical_fish_spawn_egg": "яйце виклику тропічної риби",
  "item.minecraft.turtle_spawn_egg": "яйце виклику черепахи",
  "item.minecraft.vex_spawn_egg": "яйце виклику бісика",
  "item.minecraft.villager_spawn_egg": "яйце виклику селянина",
  "item.minecraft.vindicator_spawn_egg": "яйце виклику поборника",
  "item.minecraft.wandering_trader_spawn_egg": "яйце виклику мандрівного торговця",
  "item.minecraft.witch_spawn_egg": "яйце виклику відьми",
  "item.minecraft.wither_skeleton_spawn_egg": "яйце виклику скелета-висушувача",
  "item.minecraft.wolf_spawn_egg": "яйце виклику вовка",
  "item.minecraft.zoglin_spawn_egg": "яйце виклику зоґліна",
  "item.minecraft.zombie_spawn_egg": "яйце виклику зомбі",
  "item.minecraft.zombie_horse_spawn_egg": "яйце виклику коня-зомбі",
  "item.minecraft.zombie_villager_spawn_egg": "яйце виклику зомбі-селянина",
  "item.minecraft.zombified_piglin_spawn_egg": "яйце виклику зомбованого піґліна",
  "item.minecraft.experience_bottle": "пляшечка чар",
  "item.minecraft.fire_charge": "заряд полум'я",
  "item.minecraft.writable_book": "книга з пером",
  "item.minecraft.written_book": "написана книга",
  "item.minecraft.emerald": "смарагд",
  "item.minecraft.item_frame": "рамка",
  "block.minecraft.flower_pot": "квітковий горщик",
  "item.minecraft.carrot": "морква",
  "item.minecraft.potato": "картопля",
  "item.minecraft.baked_potato": "запечена картопля",
  "item.minecraft.poisonous_potato": "отруйна картопля",
  "item.minecraft.map": "порожня мапа",
  "item.minecraft.golden_carrot": "золота морква",
  "block.minecraft.skeleton_skull": "череп скелета",
  "block.minecraft.wither_skeleton_skull": "череп скелета-висушувача",
  "block.minecraft.player_head": "голова гравця",
  "block.minecraft.zombie_head": "голова зомбі",
  "block.minecraft.creeper_head": "голова кріпера",
  "block.minecraft.dragon_head": "голова дракона",
  "item.minecraft.carrot_on_a_stick": "морква на паличці",
  "item.minecraft.warped_fungus_on_a_stick": "химерний гриб на паличці",
  "item.minecraft.nether_star": "зірка незеру",
  "item.minecraft.pumpkin_pie": "гарбузовий пиріг",
  "item.minecraft.firework_rocket": "ракетний феєрверк",
  "item.minecraft.firework_star": "зірка феєрверку",
  "item.minecraft.enchanted_book": "зачарована книга",
  "item.minecraft.nether_brick": "незерська цеглина",
  "item.minecraft.quartz": "незерський кварц",
  "item.minecraft.tnt_minecart": "вагонетка з динамітом",
  "item.minecraft.hopper_minecart": "вагонетка з воронкою",
  "item.minecraft.prismarine_shard": "уламок призмарину",
  "item.minecraft.prismarine_crystals": "кристал призмарину",
  "item.minecraft.rabbit": "сирий кролик",
  "item.minecraft.cooked_rabbit": "смажений кролик",
  "item.minecraft.rabbit_stew": "тушкований кролик",
  "item.minecraft.rabbit_foot": "кроляча лапка",
  "item.minecraft.rabbit_hide": "кроляча шкурка",
  "item.minecraft.armor_stand": "стійка для броні",
  "item.minecraft.iron_horse_armor": "залізна кінська броня",
  "item.minecraft.golden_horse_armor": "золота кінська броня",
  "item.minecraft.diamond_horse_armor": "діамантова кінська броня",
  "item.minecraft.leather_horse_armor": "шкіряна кінська броня",
  "item.minecraft.lead": "повідець",
  "item.minecraft.name_tag": "ярлик",
  "item.minecraft.command_block_minecart": "вагонетка з командним блоком",
  "item.minecraft.mutton": "сира баранина",
  "item.minecraft.cooked_mutton": "смажена баранина",
  "block.minecraft.white_banner": "білий стяг",
  "block.minecraft.orange_banner": "помаранчевий стяг",
  "block.minecraft.magenta_banner": "пурпуровий стяг",
  "block.minecraft.light_blue_banner": "блакитний стяг",
  "block.minecraft.yellow_banner": "жовтий стяг",
  "block.minecraft.lime_banner": "лаймовий стяг",
  "block.minecraft.pink_banner": "рожевий стяг",
  "block.minecraft.gray_banner": "сірий стяг",
  "block.minecraft.light_gray_banner": "світло-сірий стяг",
  "block.minecraft.cyan_banner": "бірюзовий стяг",
  "block.minecraft.purple_banner": "фіолетовий стяг",
  "block.minecraft.blue_banner": "синій стяг",
  "block.minecraft.brown_banner": "коричневий стяг",
  "block.minecraft.green_banner": "зелений стяг",
  "block.minecraft.red_banner": "червоний стяг",
  "block.minecraft.black_banner": "чорний стяг",
  "item.minecraft.end_crystal": "кристал енду",
  "item.minecraft.chorus_fruit": "фрукт хорусу",
  "item.minecraft.popped_chorus_fruit": "спечений фрукт хорусу",
  "item.minecraft.beetroot": "буряк",
  "item.minecraft.beetroot_seeds": "насіння буряка",
  "item.minecraft.beetroot_soup": "борщ",
  "item.minecraft.dragon_breath": "дихання дракона",
  "item.minecraft.splash_potion": "вибухове нестворюване зілля□немає ефектів",
  "item.minecraft.spectral_arrow": "спектральна стріла",
  "item.minecraft.tipped_arrow": "нестворюванна оброблена стріла□немає ефектів",
  "item.minecraft.lingering_potion": "осідаюче нестворюванне зілля□немає ефектів",
  "item.minecraft.shield": "щит",
  "item.minecraft.elytra": "елітри",
  "item.minecraft.spruce_boat": "смерековий човен",
  "item.minecraft.birch_boat": "березовий човен",
  "item.minecraft.jungle_boat": "човен з тропічного дерева",
  "item.minecraft.acacia_boat": "човен з акації",
  "item.minecraft.dark_oak_boat": "човен з деревини темного дубу",
  "item.minecraft.totem_of_undying": "тотем безсмертя",
  "item.minecraft.shulker_shell": "ракушняк шалкера",
  "item.minecraft.iron_nugget": "залізний самородок",
  "item.minecraft.knowledge_book": "книга знань",
  "item.minecraft.debug_stick": "палиця відладки",
  "item.minecraft.music_disc_13": "платівка□c418 - 13",
  "item.minecraft.music_disc_cat": "платівка□c418 – cat",
  "item.minecraft.music_disc_blocks": "платівка□c418 – blocks",
  "item.minecraft.music_disc_chirp": "платівка□c418 – chirp",
  "item.minecraft.music_disc_far": "платівка□c418 – far",
  "item.minecraft.music_disc_mall": "платівка□c418 – mall",
  "item.minecraft.music_disc_mellohi": "платівка□c418 – mellohi",
  "item.minecraft.music_disc_stal": "платівка□c418 – stal",
  "item.minecraft.music_disc_strad": "платівка□c418 – strad",
  "item.minecraft.music_disc_ward": "платівка□c418 – ward",
  "item.minecraft.music_disc_11": "платівка□c418 - 11",
  "item.minecraft.music_disc_wait": "платівка□c418 – wait",
  "item.minecraft.music_disc_pigstep": "платівка□лейна рейн — pigstep",
  "item.minecraft.trident": "тризубець□□коли в основній руці:□+8 сила атаки□-2.9 швидкість атаки",
  "item.minecraft.phantom_membrane": "перетинка фантома",
  "item.minecraft.nautilus_shell": "мушля навтилуса",
  "item.minecraft.heart_of_the_sea": "серце моря",
  "item.minecraft.crossbow": "арбалет",
  "item.minecraft.suspicious_stew": "підозріла юшка",
  "block.minecraft.loom": "ткацький верстат",
  "item.minecraft.flower_banner_pattern": "візерунок стяга□квітка",
  "item.minecraft.creeper_banner_pattern": "візерунок стяга□емблема з кріпером",
  "item.minecraft.skull_banner_pattern": "візерунок стяга□емблема черепа",
  "item.minecraft.mojang_banner_pattern": "візерунок стяга□річ",
  "item.minecraft.globe_banner_pattern": "візерунок стяга□емблема з глобусом",
  "item.minecraft.piglin_banner_pattern": "візерунок стяга□рило",
  "block.minecraft.composter": "компостер",
  "block.minecraft.barrel": "діжка",
  "block.minecraft.smoker": "коптильня",
  "block.minecraft.blast_furnace": "плавильна піч",
  "block.minecraft.cartography_table": "картографічний стіл",
  "block.minecraft.fletching_table": "стіл лучника",
  "block.minecraft.grindstone": "точило",
  "block.minecraft.lectern": "аналой",
  "block.minecraft.smithing_table": "верстат коваля",
  "block.minecraft.stonecutter": "каменеріз",
  "block.minecraft.bell": "дзвін",
  "block.minecraft.lantern": "ліхтар",
  "block.minecraft.soul_lantern": "ліхтар душ",
  "item.minecraft.sweet_berries": "солодкі ягоди",
  "block.minecraft.campfire": "багаття",
  "block.minecraft.soul_campfire": "багаття душ",
  "block.minecraft.shroomlight": "світлогриб",
  "item.minecraft.honeycomb": "медові стільники",
  "block.minecraft.bee_nest": "бджолине гніздо",
  "block.minecraft.beehive": "вулик",
  "item.minecraft.honey_bottle": "пляшечка меду",
  "block.minecraft.honey_block": "блок меду",
  "block.minecraft.honeycomb_block": "блок стільників",
  "block.minecraft.lodestone": "магнетит",
  "block.minecraft.netherite_block": "незеритовий блок",
  "block.minecraft.ancient_debris": "стародавні залишки",
  "block.minecraft.target": "мішень",
  "block.minecraft.crying_obsidian": "плакучий обсидіан",
  "block.minecraft.blackstone": "чорнокамінь",
  "block.minecraft.blackstone_slab": "плита з чорнокаменю",
  "block.minecraft.blackstone_stairs": "сходи з чорнокаменю",
  "block.minecraft.gilded_blackstone": "позолочений чорнокамінь",
  "block.minecraft.polished_blackstone": "полірований чорнокамінь",
  "block.minecraft.polished_blackstone_slab": "плита з полірованого чорнокаменю",
  "block.minecraft.polished_blackstone_stairs": "сходи з полірованого чорнокаменю",
  "block.minecraft.chiseled_polished_blackstone": "точений полірований чорнокамінь",
  "block.minecraft.polished_blackstone_bricks": "полірована чорнокам‘яна цегла",
  "block.minecraft.polished_blackstone_brick_slab": "плита з полірованої чорнокам'яної цегли",
  "block.minecraft.polished_blackstone_brick_stairs": "сходи з полірованої чорнокам'яної цегли",
  "block.minecraft.cracked_polished_blackstone_bricks": "тріснута полірована чорнокам'яна цегла",
  "block.minecraft.respawn_anchor": "якір відродження",
}
export const uk_ua = items; 
